<template>
  <div class="p-col-12">
    <page-header title="forms.quick-protocol.title"/>
    <form @submit.prevent="save">

      <card :header="$t('forms.quick-protocol.card-title')" class="p-col-12">
        <coff-input-text v-model="form.name" label="forms.quick-protocol.name" class="p-col-12 p-md-6 p-lg-4" :error="validation.name" />
        <coff-input-radio v-model="form.active" @update="forceUpdateField('active', $event)" :options="options" label="forms.quick-protocol.isActive" class="p-col-12 p-md-8 p-lg-2" :error="validation.active"/>
        <coff-input-auto-complete v-if="allTypeServices" v-model="form.mainService" label="forms.protocol.type-service" class="p-col-10 p-md-6 p-lg-6" :itens="allTypeServices" field="name" :error="validation.mainService" :func-suggestions="searchTypeService" :dropdown="true"/>

        <coff-input-auto-complete v-if="typeServices" v-model="selectedTypeService" label="forms.quick-protocol.type-services" class="p-col-10 p-md-6 p-lg-6" :itens="typeServices" field="name" :func-suggestions="searchTypeService" :dropdown="true"/>
        <div class="p-col-2 p-mt-3">
          <Button icon="pi pi-plus small" class="p-button-rounded small-rounded-button" :title="$t('forms.quick-protocol.add-type-service')" @click.prevent="addService" />
        </div>

        <div class="p-col-12">
          <div v-for="(service, index) in form.typeServices" :key="index">
            <div class="p-d-flex p-col-12 line-content line-of-service p-mb-2">
              <div class="text-vertical-center">
                {{service.name}}
              </div>
              <div class="p-ml-auto text-vertical-center small" style="min-width: fit-content;">
                <a class="cursor-pointer" @click.prevent="removeService(service, index)"><i class="p-ml-2 pi pi-times small" :title="$t('forms.quick-protocol.remove-type-service')"/></a>
              </div>
            </div>
          </div>
        </div>

        <div class="p-col-12">
          <Button :label="$t('btn.save&continue')" class="p-button-success" style="float: right;"/>
        </div>
      </card>

    </form>
  </div>
</template>

<script>

import ValidationUtils from "@/utils/ValidationUtils";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import PageHeader from "@/components/page/PageHeader";
import EventBus from "@/commons/EventBus";
import QuickProtocolCreateBusiness from "@/business/QuickProtocolCreateBusiness";
import TypeServiceBusiness from "@/business/TypeServiceBusiness";

export default {
  name: "QuickProtocolCreateForm",
  components: {PageHeader},
  data(){
    return {
      form: {
        typeServices: [],
      },
      validation: {
        name: false,
        active: false,
        mainService: false,
      },
      selectedTypeService: null,
      allTypeServices: null,
      typeServices: null,
      options: [
        {value: true, label: 'field.default.yes'},
        {value: false, label: 'field.default.no'}
      ],
    }
  },

  async mounted(){
    const id = this.$route.params.id;
    if(id){
      EventBus.loadingPage(true);
      this.form =  {... await QuickProtocolCreateBusiness.getById(id)};
      this.form.typeServices = this.form.typeServices == null ? [] : this.form.typeServices;
      EventBus.loadingPage(false);
    }
    this.typeServices =  await TypeServiceBusiness.getAllActive();
    this.allTypeServices = [...this.typeServices];
    this.removeSelectedFromList();
    this.selectDefaultMainService();
  },

  methods: {

    selectDefaultMainService(){
      if(this.form.mainService){
        this.form.mainService = this.allTypeServices.filter(ts => ts.id === this.form.mainService.id)[0];
      }
    },

    async save(){
      this.validation = ValidationUtils.basicValidation(this.validation, this.form);
      if(!this.validation.erros){
        const response = await QuickProtocolCreateBusiness.save(this.form, this.form.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          this.form.id = response.id;
          ToastMessageBusiness.showSuccess();
        }
      }
    },

    forceUpdateField(field, value){
      this.$set(this.form, field, value);
    },

    removeService(service){
      if(service.id) {
        this.typeServices.push(service);
        this.$set(this.form, 'typeServices', this.form.typeServices.filter((s) => s.id !== service.id));
      }
    },

    addService(){
      if(this.selectedTypeService && this.isOutOffList(this.selectedTypeService)){
        this.form.typeServices.push(this.selectedTypeService);
        this.$set(this, 'typeServices', this.typeServices.filter((s) => s.id !== this.selectedTypeService.id));
        this.$set(this, 'selectedTypeService', null);
      }
    },

    isOutOffList(typeService){
      return this.form.typeServices.filter(ts => ts.id === typeService.id).length === 0;
    },

    removeSelectedFromList(){
      this.$set(this, 'typeServices', this.typeServices.filter(ts => !(this.form.typeServices.filter(fts => ts.id === fts.id).length > 0)));
    },

    async searchTypeService(name){
      return await TypeServiceBusiness.searchByName(name);
    },

  }

}
</script>

<style scoped>

</style>